import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=3c20c958&scoped=true"
import script from "./questionDetail.vue?vue&type=script&lang=js"
export * from "./questionDetail.vue?vue&type=script&lang=js"
import style0 from "./questionDetail.vue?vue&type=style&index=0&id=3c20c958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c20c958",
  null
  
)

export default component.exports